import React from 'react';
import { useDispatch } from 'react-redux';
import { useRouteError } from 'react-router-dom';
import ErrorPage from 'components/ErrorPage';
import { toggleApplicationErrorState } from 'modules/App';

const ErrorBoundary = () => {
  const error = useRouteError();
  const dispatch = useDispatch();

  if (error) {
    const errorPayload = {
      message: error.message,
      stack: error.stack?.split('\n'),
    };
    dispatch(toggleApplicationErrorState(true, errorPayload));
    return <ErrorPage errorPayload={errorPayload} />;
  }
};

export default ErrorBoundary;